import React from "react";
import styled from "styled-components";
import { Colors } from "../../../config";

const StatusChip = ({ status }) => {
  switch (status) {
    case "invoiced":
      return <ChipWrapper bgColor={Colors.greenHaze}>Closed</ChipWrapper>;
    case "completed":
      return <ChipWrapper bgColor={Colors.greenHaze}>Closed</ChipWrapper>;
    case "booked":
      return <ChipWrapper bgColor={Colors.greenHaze}>Booked</ChipWrapper>;
    case "cancel":
      return <ChipWrapper bgColor={Colors.flashyRed}>Cancel</ChipWrapper>;
    case "invoice_error":
      return <ChipWrapper bgColor={Colors.greenHaze}>Booked</ChipWrapper>;
    case "cancel_reverted":
      return (
        <ChipWrapper bgColor={Colors.flashyRed}>
          Cancel And Reverted
        </ChipWrapper>
      );
    case "cancel_through_customer":
      return (
        <ChipWrapper bgColor={Colors.flashyRed}>
          Cancelled By Customer
        </ChipWrapper>
      );
    case "cancel_through_agent":
      return (
        <ChipWrapper bgColor={Colors.flashyRed}>Cancelled By Agent</ChipWrapper>
      );
    case "assigned":
      return <ChipWrapper bgColor={Colors.skyBlue}>Assigned</ChipWrapper>;
    case "processing":
      return (
        <ChipWrapper bgColor={Colors.skyBlue}>
          Leave Pending Approval
        </ChipWrapper>
      );
    case "new":
      return <ChipWrapper bgColor={Colors.amber}>New</ChipWrapper>;
    case "cancellation_pending_joury_approval":
      return (
        <ChipWrapper bgColor={Colors.fieryRed}>
          Cancellation Pending Joury Approval
        </ChipWrapper>
      );

    case "cancelled_full_refund":
      return (
        <ChipWrapper bgColor={Colors.fieryRed}>
          Cancelled With Full Refund
        </ChipWrapper>
      );

    case "cancelled_partial_refund":
      return (
        <ChipWrapper bgColor={Colors.fieryRed}>
          Cancelled With Partial Refund
        </ChipWrapper>
      );

    case "cancelled_non_refundable":
      return (
        <ChipWrapper bgColor={Colors.fieryRed}>
          Cancelled Without Refund
        </ChipWrapper>
      );
    case "requested_cancellation":
      return (
        <ChipWrapper bgColor={Colors.fieryRed}>
          Requested Cancellation
        </ChipWrapper>
      );
    case "requested_cancellation_revert":
      return (
        <ChipWrapper bgColor={Colors.fieryRed}>
          Requested Cancellation
        </ChipWrapper>
      );
    case "awaiting_clarification":
      return (
        <ChipWrapper bgColor={Colors.mariGoldorange}>
          Awaiting Clarification
        </ChipWrapper>
      );
    case "amended":
      return <ChipWrapper bgColor={"#ffc109"}>Amended</ChipWrapper>;
    case "amendment_initiated":
      return <ChipWrapper bgColor={"#03A9F4"}>Amendment Initiated</ChipWrapper>;
    case "rejected":
      return <ChipWrapper bgColor={Colors.red}>Rejected</ChipWrapper>;
    case "cancelled":
      return <ChipWrapper bgColor={Colors.flashyRed}>Cancelled</ChipWrapper>;
    case "on_hold":
      return (
        <ChipContainer>
          <ChipMessage>
            Request on hold due to insufficient credit limit. Finance notified
            for credit refill; action is pending confirmation.
          </ChipMessage>
          <ChipWrapper
            bgColor={Colors.doveGray}
            fontColor={Colors.goldenYellow}
          >
            On Hold
          </ChipWrapper>
        </ChipContainer>
      );
    default:
      return (
        <ChipWrapper bgColor={Colors.mariGoldorange}>
          {status.replaceAll("_", "")}
        </ChipWrapper>
      );
  }
};

export default StatusChip;

const ChipMessage = styled.span`
  display: none;
  font-size: 0.7rem;
  position: absolute;
  padding: 0.5rem;
  background: white;
  border-radius: 0.25rem;
  width: 100%;
  box-shadow: 0px 0px 5px lightgrey;
  top: -4.75rem;
`;

const ChipContainer = styled.div`
  position: relative;
  :hover {
    > span {
      display: block;
    }
  }
`;

const ChipWrapper = styled.div`
  width: auto;
  height: 3rem;
  border-radius: 2.5rem;
  padding: 0 0.25rem;
  background-color: ${(props) => props.bgColor};
  color: ${(props) => (props.fontColor ? props.fontColor : Colors.white)};
  font-weight: 500;
  font-size: 0.875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
`;
